var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"alarmAlertAudio",attrs:{"id":"alarmAlert","data-cy":"alarmAlertAudio"}},[_c('source',{attrs:{"src":("media/" + _vm.alarmSourceFile)}})])}
var staticRenderFns = []

export { render, staticRenderFns }